import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-06eff826")

_pushScopeId("data-v-06eff826")
const _hoisted_1 = { class: "fridgedetails-selectbuttons" }
const _hoisted_2 = { class: "fridgedetails-selectbuttons-container" }
const _hoisted_3 = { class: "fridgedetails-selectbuttons-container-button-text" }
const _hoisted_4 = { class: "fridgedetails-selectbuttons-container-button-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock("div", {
        class: "fridgedetails-selectbuttons-container-button",
        key: _ctx.updateDisplayKey,
        style: _ctx.styleLeft,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.leftClick(...args)))
      }, [
        _createVNode("span", _hoisted_3, _toDisplayString(_ctx.leftButtonTitle), 1)
      ], 4)),
      (_openBlock(), _createBlock("div", {
        class: "fridgedetails-selectbuttons-container-button",
        key: _ctx.updateDisplayKey,
        style: _ctx.styleRight,
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.rightClick(...args)))
      }, [
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.rightButtonTitle), 1)
      ], 4))
    ])
  ]))
})